<template>
    <MainPage pageTitle="แจ้งเคลมแบบไม่ลงทะเบียน" bgClass="bg-white">
        <div class="map-area rounded-t-10">
            <div class="absolute w-full h-full top-0 left-0 flex items-center justify-center rounded-t-10">
                กำลังเตรียมแผนที่...
            </div>
            <div class="absolute w-full h-full top-0 left-0 rounded-t-10" ref="elemMaps"></div>
        </div>
        <div class="p-6">
            <template v-if="isPageLoaded && isWebConfigLoaded">
                <ClaimNoRegisterForm ref="elemForm" :formType="formType" :formConfig="claimNonRegisterConfig" :isDisable="isDisable" :markerPosition="markerPosition"
                    @onSubmit="onSubmitForm($event)" />
            </template>
        </div>
    </MainPage>
</template>
<script>
import { computed, inject, ref, onMounted } from 'vue';
import MapsService from '@/module/Maps/service/MapsService';
import useLoadingModal from '@/helper/composable/modal/useLoadingModal';
import ConfigManager from '@/config/ConfigManager';
import WebConfigStore from "@/store/WebConfigStore"
import ClaimNonRegisterService from "../service/ClaimNonRegisterService"
import Utility from '@/helper/Utility';
import { useRoute } from 'vue-router';
import { useTracking } from '@/feature/TrackingFeature';

// component
import MainPage from '@/components/Layout/Page/MainPage.vue';
import ClaimNoRegisterForm from "../component/ClaimNoRegisterForm.vue"

// assets
import IconMapPinNormal from "@/assets/icon/ic-pin-location-solid.svg"

export default {
    components: {
        MainPage,
        ClaimNoRegisterForm
    },
    setup: function () {
        const isPageLoaded = ref(false)
        /**@type {import("@/types/Modal.d").ModalStore} */
        const modalStore = inject("ModalStore");
        const modalController = modalStore.methods.getModalController()
        const { loadingModal } = useLoadingModal(modalStore);
        const { webConfig, isWebConfigLoaded } = WebConfigStore()
        const isInLineApp = ref(false)
        const route = useRoute()
        const lineUserId = ref()
        const tracking = useTracking()

        let googleKey = ConfigManager.getGoogleMapsKey()
        const elemMaps = ref(null)
        const isDisable = ref(true)
        const mapService = MapsService(elemMaps, {
            apiKey: googleKey,
            version: "weekly",
            libraries: ["places"]
        }, {
            zoom: 15
        })
        const formType = ref("now")
        const markerPosition = ref(null)

        const claimNonRegisterConfig = computed(() => {
            if (isWebConfigLoaded.value && webConfig.value?.claim?.nonRegister != null) {
                return webConfig.value.claim.nonRegister
            }
            return null
        })

        const getCurrentLatLng = function () {
            let markerPosition = mapService.pinMarker.value.getPosition()
            if (markerPosition == null) {
                return {
                    lat: null,
                    lng: null
                }
            }

            return {
                lat: markerPosition.lat(),
                lng: markerPosition.lng()
            }
        }

        /**
         *
         * @param {import("../model/ClaimNoRegisterModel").ClaimNoRegisterModel} model
         */
        const onSubmitForm = function (model) {
            tracking.screenName('claim_not_register')
            tracking.event("claim_not_register_page", "click_claim_not_register", formType.value, "");

            let latLng = getCurrentLatLng()
            model.setLatLng(latLng).setLineId(lineUserId.value)
            let params = model.getParams()
            params.place = markerPosition.value

            console.log(params)

            loadingModal.show()
            ClaimNonRegisterService.apiSubmitClaimNonRegister(params).then((res) => {
                console.log(res)
                modalController.claimAlertModal.clearModal()
                    .setTitle('แจ้งเคลมสำเร็จ')
                    .setMsg('คุณทำการแจ้งเคลมสำเร็จแล้ว')
                    .show({
                        btnComponent: 'line',
                        msgClass: 'pb-10',
                    })
            }).catch((err) => {
                console.log(err)
                modalController.claimAlertModal.clearModal()
                    .setTitle('แจ้งเคลมไม่สำเร็จ')
                    .setMsg(err.message)
                    .show({
                        btnOk: 'แจ้งเคลมอีกครั้ง',
                        msgClass: 'pb-10',
                    })
                // .setMsg('แจ้งเคลมไม่สำเร็จ กรุณาแจ้งเคลมใหม่อีกครั้ง')
            }).finally(() => {
                loadingModal.hide()
            })
        }

        const initForm = function () {
            //#region init form in liff browser
            loadingModal.show()
            mapService.getCurrentLocation().then(() => {
                return mapService.initMaps()
            }).then(() => {
                mapService.pinCurrent(null, IconMapPinNormal, null, null, true)
            }).catch((err) => {
                console.log(err)
            }).finally(async() => {
                await getPinName()
                locationUpdated()
                
                if (formType.value == 'now') {
                    isDisable.value = false
                } else {
                    alertPopup()
                }

                isPageLoaded.value = true
                loadingModal.hide()
            })
            //#endregion init form in line browser
        }

        const updateMap = function () {
            isDisable.value = false
        }

        const locationUpdated = function () {
            // Add event listener to pin marker dragend event
            mapService.pinMarker.value.addListener('dragend', () => {
                const latlng = getCurrentLatLng();
                console.log('Pin location updated:', latlng);
                getPinName()
                updateMap()
                // Do something with the updated location
            });
        }

        const alertPopup = function () {
            modalController.alertModal
                            .clearModal()
                            .setTitle('กรุณาปักหมุดแผนที่')
                            .setMsg('สำหรับแจ้งเคลมให้ตรงกับสถานที่นัดหมาย')
                            .show()
            modalController.alertModal.onClickOk(() => {
                locationUpdated()
            })
        }

        const getPinName = function () {
            const latlng = getCurrentLatLng();
            return new Promise((resolve) => {
                // mapService.getAddressByGeolocation(latlng) returns a Promise that resolves with a string (the address)
                mapService.getAddressByGeolocation(latlng).then((res) => {
                    // set the marker position to the resolved address
                    markerPosition.value = res
                    // resolve the Promise with a value of true
                    resolve(true)
                })
            })
        }

        onMounted(() => {
            lineUserId.value = route.query?.uid ?? null
            formType.value = route.query?.type ?? "now"

            // need uid on url that redirect from nodejs landing flow
            if(Utility.isEmptyStr(lineUserId.value)){
                let urlLanding = Utility.getWebUrl("Landing.aspx?target_page=Claim.aspx&type=" + formType.value)
                window.location.href = urlLanding // relogin
            }

            initForm()
        })

        return {
            elemMaps,
            modalController,
            formType,
            isPageLoaded,
            claimNonRegisterConfig,
            isWebConfigLoaded,
            isInLineApp,
            onSubmitForm,
            isDisable,
            updateMap,
            markerPosition
        }
    },
}
</script>

<style lang="scss" scoped>
.map-area {
    height: 190px;
    @apply flex-none bg-a-gray-d0d0ce relative;
}
</style>
